/**
 * How many people a game seats, in words.
 *
 * Three screens said this and all three said it the same wrong way: the
 * library card, the game's own page and the host's game picker each built the
 * string inline, and each of them rendered a patience as "1 players". Nobody
 * noticed while the only one-player game was hypothetical; the library now
 * puts three of them in a row under a heading that says Solitaire.
 *
 * One function so the next reading of it - "up to 6", say, or a range that
 * says which counts actually play well - is one edit rather than three.
 */
export function playerCount(min: number, max: number): string {
  if (min === max) return min === 1 ? '1 player' : `${String(min)} players`;
  return `${String(min)}–${String(max)} players`;
}
